import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum PhoneNumberUseCase {
  Marketing = "marketing",
  Transactional = "transactional",
  Support = "support",
}

export enum PhoneNumberProvider {
  Telnyx = "telnyx",
  Bandwidth = "bandwidth",
}

export enum TextMessagingVerificationStatus {
  Unverified = "unverified",
  Pending = "pending",
  Verified = "verified",
}

export enum TollFreeVerificationStatus {
  Verified = "Verified",
  Rejected = "Rejected",
  WaitingForVendor = "Waiting For Vendor",
  WaitingForCustomer = "Waiting For Customer",
  WaitingForTelnyx = "Waiting For Telnyx",
  InProgress = "In Progress",
}

interface VoiceMetadata {
  billingGroupId: string;
  sipConnectionId: string;
}

export const PhoneNumberSchema = z.object({
  _id: zExt.objectId(),
  number: z.string(),
  team: zExt.objectId(),
  provider: z.enum(PhoneNumberProvider),
  useCase: z.enum(PhoneNumberUseCase),
  messagingMetadata: z
    .object({ verificationStatus: z.enum(TextMessagingVerificationStatus) })
    .optional(),
  voiceMetadata: z
    .object({ billingGroupId: z.string(), sipConnectionId: z.string() })
    .optional(),
});

export type PhoneNumber = z.infer<typeof PhoneNumberSchema>;

export type MessagingMetadata = NonNullable<PhoneNumber["messagingMetadata"]>;

export type VoiceEnabledPhoneNumber = PhoneNumber & {
  voiceMetadata: VoiceMetadata;
};

export function isVoiceEnabledPhoneNumber(
  phoneNumber: PhoneNumber,
): phoneNumber is VoiceEnabledPhoneNumber {
  return !!phoneNumber.voiceMetadata;
}

export function determineCountryCode(phoneNumber: string): string | undefined {
  if (phoneNumber.startsWith("+1")) {
    return "US";
  }
  // extend for other country codes as needed
  return undefined;
}
